import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את התחושה",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לשכנע את עצמי אחרת.",
      "אני רק שם/ה לב: יש בי תחושה שהחיים עברו לידי.",
      "אני כאן."
    ],
      [
      "היום אני לא מנסה לשכנע את עצמי אחרת.",
      "אני רק שם/ה לב: יש בי תחושה שהחיים עברו לידי.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי התחושה הזו חזקה במיוחד?",
      "מה אני אומר/ת לעצמי ברגעים האלה?",
      "מה אני מרגיש/ה בגוף?"
    ],
      [
      "מתי התחושה הזו חזקה במיוחד?",
      "מה אני אומר/ת לעצמי ברגעים האלה?",
      "מה אני מרגיש/ה בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "התחושה היא חוויה, לא אני."
    ],
      [
      "התחושה היא חוויה, לא אני."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני כאן עם התחושה\".",
      "נשימה אחת + \"אני כאן עם התחושה\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שבו התחושה מתחילה.",
      "אני רק שם/ה לב.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני שם/ה לב לרגע שבו התחושה מתחילה.",
      "אני רק שם/ה לב.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה ממש לפני שהתחושה עולה?",
      "איפה זה פוגש אותי ביום?",
      "ממה אני מנסה להימנע?"
    ],
      [
      "מה קורה ממש לפני שהתחושה עולה?",
      "איפה זה פוגש אותי ביום?",
      "ממה אני מנסה להימנע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי קצת מרווח."
    ],
      [
      "ברגע הראשון יש לי קצת מרווח."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשזה מתחיל.",
      "נשימה אחת כשזה מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "סימני גוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי.",
      "אני כאן."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הגוף מרגיש את התחושה?",
      "מה הגוף מנסה להגן?",
      "מה יכול להתרכך מעט?"
    ],
      [
      "איפה הגוף מרגיש את התחושה?",
      "מה הגוף מנסה להגן?",
      "מה יכול להתרכך מעט?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף שלי מנסה לשמור עליי."
    ],
      [
      "הגוף שלי מנסה לשמור עליי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קפץ מיד?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ],
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קפץ מיד?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה שנדם",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שנדם בי.",
      "לא כדי להאשים.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני שם/ה לב למה שנדם בי.",
      "לא כדי להאשים.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בדרך כלל חסר לי?",
      "מתי אני מרגיש/ה מעט יותר חי/ה?",
      "מה אני מתגעגע/ת אליו?"
    ],
      [
      "מה בדרך כלל חסר לי?",
      "מתי אני מרגיש/ה מעט יותר חי/ה?",
      "מה אני מתגעגע/ת אליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב למה שנדם זה כבר חיבור."
    ],
      [
      "לשים לב למה שנדם זה כבר חיבור."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב דבר אחד שאני מתגעגע/ת אליו.",
      "לכתוב דבר אחד שאני מתגעגע/ת אליו."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול הפנימי.",
      "בלי להכריח.",
      "אני כאן."
    ],
      [
      "היום אני מקשיב/ה לקול הפנימי.",
      "בלי להכריח.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הקול הפנימי אומר על התחושה הזו?",
      "מה הקול הזה בוחר/ת ממני?",
      "איזה קול עדין יותר נשמע בי?"
    ],
      [
      "מה הקול הפנימי אומר על התחושה הזו?",
      "מה הקול הזה בוחר/ת ממני?",
      "איזה קול עדין יותר נשמע בי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול פנימי רך הוא התחלה."
    ],
      [
      "קול פנימי רך הוא התחלה."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי רך אחד.",
      "משפט פנימי רך אחד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "צורך קטן",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך שמתחת לתחושה.",
      "אני לא פותר/ת.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך שמתחת לתחושה.",
      "אני לא פותר/ת.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ],
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה כדי להרגיש מעט יותר חי/ה?",
      "מה בי מבקש חום או קרבה?",
      "איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ],
      [
      "מה אני בוחר/ת/ה כדי להרגיש מעט יותר חי/ה?",
      "מה בי מבקש חום או קרבה?",
      "איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מאחורי התחושה יש בקשה."
    ],
      [
      "מאחורי התחושה יש בקשה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב בקשה אחת לעצמי.",
      "לכתוב בקשה אחת לעצמי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חיבור קטן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי.",
      "אני כאן."
    ],
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה נותן לי תחושת חיבור עכשיו?",
      "איזו מילה מרגיעה אותי?",
      "מה אני יכול/ה לתת לעצמי לרגע?"
    ],
      [
      "מה נותן לי תחושת חיבור עכשיו?",
      "איזו מילה מרגיעה אותי?",
      "מה אני יכול/ה לתת לעצמי לרגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חיבור קטן הוא עדיין חיבור."
    ],
      [
      "חיבור קטן הוא עדיין חיבור."
    ]
    ),
    action: localizedGenderNode(
      "מילה שקטה אחת בלב.",
      "מילה שקטה אחת בלב."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "חמלה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מדבר/ת אל עצמי בעדינות.",
      "לא כמו שופט/ת.",
      "אני כאן."
    ],
      [
      "היום אני מדבר/ת אל עצמי בעדינות.",
      "לא כמו שופט/ת.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "על מה אני יכול/ה לסלוח לעצמי?"
    ],
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "על מה אני יכול/ה לסלוח לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עדינות לא מבטלת את התחושה."
    ],
      [
      "עדינות לא מבטלת את התחושה."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לעצמי.",
      "משפט רך אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה פנימית",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה.",
      "אני כאן."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הבטן מתרככת מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הבטן מתרככת מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה להזיז אותי."
    ],
      [
      "בקשה אחת יכולה להזיז אותי."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "שינוי קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן בתוך היום.",
      "לא מהפכה, רק צעד קטן.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני בוחר/ת שינוי קטן בתוך היום.",
      "לא מהפכה, רק צעד קטן.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה שינוי קטן שאני מוכן/ה לנסות השבוע?",
      "מתי ביום הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ],
      [
      "מה שינוי קטן שאני מוכן/ה לנסות השבוע?",
      "מתי ביום הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שינוי קטן הוא התחלה אמיתית."
    ],
      [
      "שינוי קטן הוא התחלה אמיתית."
    ]
    ),
    action: localizedGenderNode(
      "לבחור רגע אחד שבו אני מנסה אותו.",
      "לבחור רגע אחד שבו אני מנסה אותו."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "בחירה בנוכחות",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת את רגע הבחירה.",
      "בין היעלמות לבין נוכחות.",
      "אני כאן."
    ],
      [
      "היום אני בודק/ת את רגע הבחירה.",
      "בין היעלמות לבין נוכחות.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת כשאני מרגיש/ה שהחיים עברו לידי?",
      "איזו בחירה קטנה של נוכחות אפשרית לי?",
      "איך אני מרגיש/ה אחרי הבחירה הזו?"
    ],
      [
      "מה אני בוחר/ת כשאני מרגיש/ה שהחיים עברו לידי?",
      "איזו בחירה קטנה של נוכחות אפשרית לי?",
      "איך אני מרגיש/ה אחרי הבחירה הזו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בחירה קטנה משנה את הכיוון."
    ],
      [
      "בחירה קטנה משנה את הכיוון."
    ]
    ),
    action: localizedGenderNode(
      "לומר בלב \"אני בוחר/ת להיות כאן\" פעם אחת.",
      "לומר בלב \"אני בוחר/ת להיות כאן\" פעם אחת."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "כיוון קטן",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לאן אני רוצה לנוע.",
      "לא רחוק, רק כיוון קטן.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני שם/ה לב לאן אני רוצה לנוע.",
      "לא רחוק, רק כיוון קטן.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה חשוב לי להרגיש יותר בחיים?",
      "איזה ערך קטן אני רוצה לחיות היום?",
      "מה סימן קטן שזה קורה?"
    ],
      [
      "מה חשוב לי להרגיש יותר בחיים?",
      "איזה ערך קטן אני רוצה לחיות היום?",
      "מה סימן קטן שזה קורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כיוון עדין מספיק כדי להתחיל."
    ],
      [
      "כיוון עדין מספיק כדי להתחיל."
    ]
    ),
    action: localizedGenderNode(
      "משפט ערך אחד קצר.",
      "משפט ערך אחד קצר."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ],
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על התחושה הזו?",
      "מה הסימן המוקדם שאני נכנס/ת אליה?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ],
      [
      "מה למדתי על התחושה הזו?",
      "מה הסימן המוקדם שאני נכנס/ת אליה?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני לא רוצה/ת למחוק את התחושה כדי להיות נוכח/ת."
    ],
      [
      "אני לא רוצה/ת למחוק את התחושה כדי להיות נוכח/ת."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני תגובה.",
      "נשימה אחת לפני תגובה."
    ),
  },
].map(buildNormalizedDay);

export const theFeelingOfLifePassedMeByBlueprintHe = buildNormalizedPilotBlueprint({
  id: "the_feeling_of_life_passed_me_by_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "the_feeling_of_life_passed_me_by",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "תחושה שהחיים עברו לידי",
    en: "The feeling that life passed me by",
    es: "La sensación de que la vida pasó de largo",
  },
  days,
});

export default theFeelingOfLifePassedMeByBlueprintHe;
